// extracted by mini-css-extract-plugin
export default {"header":"ResetPassword_header__1kXPZ","backLink":"ResetPassword_backLink__1mkIp","arrow":"ResetPassword_arrow__w-pdA"};